export default "/images/at-icon.svg?c6981d033cebabfb5ca64a931ee54ced";